export const vehiclesBrandsUrl = 'vehicles-brands/';
export const vehiclesSubBrandsUrl = 'vehicles-sub-brands/';
export const vehiclesVersionsUrl = 'vehicles-versions/';
